<template>
  <div class="flex flex-col md:flex-row max-w-[1200px] md:mx-auto gap-3">
    <div class="hidden md:grid grid-cols-2 items-center max-w-[1200px] md:mx-auto gap-5 my-10" v-if="!isSmallScreen">
      <div
        class="flex flex-col flex-grow h-full items-center mx-auto bg-white shadow-lg p-5 group hover:bg-ROJO_LEON transition duration-300 text-center gap-5 rounded-lg max-w-[300px]"
        v-for="content in contentsCard" :key="content.id">
        <img :src="content.imgSrc" alt="ICON" class="group-hover:invert group-hover:brightness-0 w-auto h-14" />
        <h3 class="font-bold text-ROJO_LEON group-hover:text-white">
          {{ content.title }}
        </h3>
        <p class="group-hover:text-white">
          {{ content.description }}
        </p>
      </div>
    </div>
    <div v-else class="w-full">
      <Carrusel 
        class="mt-10"
        :data="cardsAdaptadas"
        :itemsPorPagina="1"
        :ClaseSlide="ClaseSlide"
        :autoplay="true" 
        :autoplayInterval="4000"
        :bucle="true"
        :habilitarBotonesNav="false"

        :motrarPuntos="true"
        PadreDotClass="pt-2"
        customDotClass="w-3 h-3"
        customActiveDotClass="bg-ROJO_LEON w-6" 
        customInactiveDotClass="bg-GRIS_CLARO_COMPLEMENTARIO_2">
        
        <!-- Slot para renderizar CardTipo1 -->
        <template #contenido="{ items }">
          <CardTipo1 v-for="(item, index) in items" :key="index" 
          :clase_contenedor_padre="item.clase_contenedor_padre" 
          :imagen_clase="item.imagen_clase"
          :imagen="item.imagen" 
          :paso="item.paso" 
          :titulo="item.titulo" 
          :texto="item.texto" />
        </template>
      </Carrusel>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, onBeforeUnmount } from 'vue';
import Carrusel from '~/components/Carruseles/Carrusel.vue';
import CardTipo1 from '~/components/Cards/CardTipo1.vue';

const ClaseSlide = ref('flex justify-center items-center px-0 md:px-4 py-2 h-[26rem] md:h-[30rem]')
const isSmallScreen = ref(false);

const handleResize = () => {
  isSmallScreen.value = window.innerWidth <= 768;
};

const contentsCard = ref([
  {
    id: 1,
    title: "GARANTÍA LEÓN A TODO EVENTO",
    imgSrc: "/img/home/garantia-leon-icon.webp",
    description:
      "La mayoría de nuestros neumáticos cuenta con una garantía extendida gratuita a todo evento. ¿Qué significa esto? Si tu neumático se daña irreparablemente producto de cualquier causa accidental durante la conducción, te lo cambiamos por uno completamente nuevo, durante un periodo de 6 meses o 10.000 kilómetros. ¡Aprovecha este beneficio único que te brinda LEÓN Servicio Automotriz!",
  },
  {
    id: 2,
    title: "COMPRA ONLINE Y PAGA EN TIENDA",
    imgSrc: "/img/home/compra-online-icon.webp",
    description:
      "Sabemos que comprar neumáticos es una inversión no menor. También que nuestros clientes no manejan todo el conocimiento a la hora de saber qué neumático escoger. Es por eso que cuando compras online damos la tranquilidad que puedas agendar en línea y pagar en tienda una vez que se haya instalado el neumático adecuado y asesorado por nuestros expertos. De todas maneras recuerda que tenemos un equipo de expertos vía telefónica que pueden ayudarte en cualquier momento.",
  },
  /*
  {
    id: 3,
    title: "REVISIÓN GRATUITA DE POR VIDA DE TUS NEUMÁTICOS",
    imgSrc: "/img/home/revision-gratuita-icon.webp",
    description:
      "Podrás visitarnos cuando quieras para una revisión completa de tus neumáticos, presión de aire o rotación. Asimismo, te ofrecemos revisiones de seguridad gratis.",
  },
  */
]);

// Adaptar los datos para CardTipo1
const cardsAdaptadas = computed(() => {
  return contentsCard.value.map(card => ({
    clase_contenedor_padre: 'w-full p-5 group hover:bg-ROJO_LEON h-full',
    imagen_clase: 'group-hover:invert group-hover:brightness-0 w-auto h-14',
    imagen: card.imgSrc,
    paso: '',
    titulo: card.title,
    texto: card.description
  }));
});

onMounted(() => {
  window.addEventListener("resize", handleResize);
  handleResize();
});

onBeforeUnmount(() => {
  window.removeEventListener("resize", handleResize);
});
</script>

<style lang="scss" scoped></style>